import * as React from 'react';
import { observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import MainStore from '@src/pages/main/store';
import Page from '../../components/page';
import PageSwiper from '@src/components/swiper/page-swiper';
import Navibar from '@src/business-components/navibar';
// import FirstScreen from '@src/pages/main/components/first-screen';
// import FeatureScreen from '@src/pages/main/components/feature-screen';
// import PassportScreen from '@src/pages/main/components/passport-screen';
// import HighlightScreen from '@src/pages/main/components/highlight-screen';
// import NewMechaScreen from '@src/pages/main/components/new-mech-screen';

import AnchorNav from '@src/business-components/anchor-nav';
import createLazyComponent from '@src/utils/create-lazy-component';
import cx from 'classnames';

const FirstScreenLazy = createLazyComponent(() => import('@src/pages/main/components/first-screen'));
const FeatureScreenLazy = createLazyComponent(() => import('@src/pages/main/components/feature-screen'));
const PassportScreenLazy = createLazyComponent(() => import('@src/pages/main/components/passport-screen'));
const HighlightScreenLazy = createLazyComponent(() => import('@src/pages/main/components/highlight-screen'));
const NewMechaScreenLazy = createLazyComponent(() => import('@src/pages/main/components/new-mech-screen'));

const styles = require('./index.less');

const Main = () => {
  const store = useStore(() => new MainStore());
  return (
    <Page className={styles.root}>
      <Navibar store={store.navibarStore} />
      <PageSwiper store={store.pageSwiperStore}>
        <div className={cx(styles.pageItem, styles.firstScreen)}>
          <FirstScreenLazy store={store.firstScreenStore} />
        </div>
        <div className={cx(styles.pageItem, styles.newMechaScreen)}>
          <NewMechaScreenLazy store={store.newMechaScreenStore} />
        </div>
        <div className={cx(styles.pageItem, styles.passportScreen)}>
          <PassportScreenLazy store={store.passportScreenStore} />
        </div>
        <div className={cx(styles.pageItem, styles.highlightScreen)}>
          <HighlightScreenLazy store={store.highlightScreenStore} />
        </div>
        <div className={cx(styles.pageItem, styles.featureScreen)}>
          <FeatureScreenLazy store={store.featureScreenStore} />
        </div>
      </PageSwiper>
      {store.pageSwiperStore.baseSwiperStore?.activeIndex !== 0 && <AnchorNav store={store.anchorNavStore} className={styles.anchorNav} />}
      <div className={styles.footerActiveBtn} onClick={store.showFooter} />
    </Page>
  );
};

export default observer(Main);
